// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1EKjz","icon":"SortAdornment_icon__14D9T","up":"SortAdornment_up__1lwp2","down":"SortAdornment_down__q57vL","active":"SortAdornment_active__1mmCt"};